import { Observable } from 'rxjs';

import { Transaction } from './transaction';

export abstract class TransactionRequestInterface {
    abstract wrap<T>(observable: Observable<T>): Observable<Transaction<T>>;
}
